@for (scheme of schemas(); track $index + scheme.scheme) {
	@if (scheme.display !== 'no') {
    @let addMarginBottom = (schemas()?.length ?? 0) > 0 && !isCartOOSRecs() && !isTabbedCarouselRecs() && !isOOSSimilarProducts() && !isVerticalGrid();
		<div
			class="product-recommendations"
      [class.hmf-mb-xxs]="addMarginBottom"
      [class.hmf-mb-md-l]="addMarginBottom"
			[class.product-recommendation-card-carousel]="homefieldCarouselEnabled()"
			[id]="sponsored() ? 'sponsored-product' : ''"
		>
			<!-- Recommendation Heading -->
			@if (!homefieldCarouselEnabled() && !isVerticalGrid() && !isSidePanelRecsRedesign()) {
				<div
					class="header3 product-recommendations-header"
					[class.alternative-instock-header]="isAlternativeInStock() || isOOSRecommendations() && !showViewMoreLink()"
          [style.width]="isPLPRecs() ? '100%' : '97%'"
				>
					@if (scheme?.certonaDisplayText) {
						<span
							[class.alternative-instock-text]="isAlternativeInStock() && !showViewMoreLink()"
							class="hmf-pl-s hmf-pl-m-0 certona-title-text"
						>
							{{ scheme?.certonaDisplayText }}
						</span>
						<hr
							class="header-hr"
							[class.sponsored-header-hr-override]="sponsored()"
						/>
					}
					@if (showViewMoreLink()) {
						<a
							href="/s/recommended-for-you"
							class="viewall"
							[attr.data-em]="'PDP_CertonaViewAll' + filterBy()"
						>
							View All
						</a>
					}
				</div>
			}

			<!-- Standard Recommendations -->
			@if (!isSidePanelRecs()) {
				<div
					class="product-recommendation-container"
					[class.alternative-instock-container]="isAlternativeInStock() || isOOSRecommendations()"
					[class.center-content]="isPLPRecs()"
					[class.product-recommendation-container--vertical-grid]="isVerticalGrid()"
				>
					<div class="product-recommendation-card-container"
						[ngClass]="{
							'pla-product-recommendation-card-container': isPlaRecommendations(),
							'hmf-p-0': homefieldCarouselEnabled(),
							'hmf-display-flex hmf-flex-row': !isVerticalGrid(),
							'product-recommendation-card-container--vertical-grid': isVerticalGrid(),
						}">
						@if (homefieldCarouselEnabled() && !showVertical()) {
							<div class="hmf-w-100 hmf-mb-xxs">
								<hmf-carousel
									[title]="scheme?.certonaDisplayText ?? ''"
									[showHeader]="showHeader()"
									[subtitle]="sponsored() ? 'Sponsored': ''"
									[showActionButton]="showViewMoreLink()"
									actionButtonTitle="View All"
									(actionButtonClicked)="goToRecommendedForYou()">
									@for (
										item of scheme?.items;
										let index = $index;
										track trackByCertona($index, item);
									) {
										@if(index < productDisplayLimit()) {
											<div class="product-recommendation-cards"
												[class.quickview]="certonaQuickviewEnabled() && showQVButtons() || isCartOOSRecs()"
												[class.oos-similar-products-recommendation]="isOOSSimilarProducts()"
												[class.recs-carousel-item]="isTabbedCarouselRecs()">
												@let isEmptyCartLCP = filterBy() === 'cartempty_rr' && index === 0;
												<hmf-product-card
													[id]="sponsored() && item?.ID ? 'spa-carousel-' + item.ID : ''"
													class="cursor-pointer"
													[attr.data-em]="criteoDataEms()[index] ?? ''"
													[productData]="recommendationDataService.mapSchemaItemToProductCardData(item, 500, isEmptyCartLCP) ?? undefined"
													[showATC]="showQVButtons() || isCartOOSRecs()"
													[buttonStyle]="isCartOOSRecs() ||  isTabbedCarouselRecs() ? 'secondary' : 'tertiary'"
													[buttonText]="isCartOOSRecs() ? 'Replace' : atcCardText()"
													[showReviewsStars]="false"
													[size]="cardSize() ? cardSize() : scheme?.cardSize"
													variant="recommendation"
													(cardClicked)="handleProductCardClicked(item)"
													(addToCartClicked)="handleATCBtnClick(item)"></hmf-product-card>
											</div>
										}
									}
								</hmf-carousel>
							</div>
						}
						@if (showVertical() && !homefieldCarouselEnabled()) {
							@for (
								item of scheme?.items;
								let index = $index;
								track trackByCertona($index, item);
							) {
								@if(index < productDisplayLimit()) {
									<div class="product-recommendation-cards"
										[ngClass]="{
											'quickview': certonaQuickviewEnabled() && showQVButtons() || isCartOOSRecs(),
											'oos-similar-products-recommendation': isOOSSimilarProducts()
										}"
									>
										<a class="hmf-display-flex hmf-flex-column hmf-align-items-stretch url"
										   [attr.data-em]="sponsored() ? 'pdp_sponsored_dsgproductpage_' + index : ''"
										   [id]="sponsored() && item.ID ? 'spa-carousel-' + item.ID : ''"
										   href="javascript:void(0)"
										   (click)="handleProductCardClicked(item)">
											<ng-container *ngTemplateOutlet="cardContent; context: { item: item, index: index }"></ng-container>
										</a>
										<button hmf-button
												id="certona-add-to-cart-{{ index }}"
												[variant]="'secondary'"
												[size]="'medium'"
												[loading]="false"
												[disabled]="false"
												[label]="isCartOOSRecs() ? 'Replace' : atcCardText()"
												class="hmf-mx-0 hmf-px-xs"
												(click)="openQuickviewPanel(item.ID, item.URL)">
											{{ isCartOOSRecs() ? 'Replace' : atcCardText() }}
										</button>
									</div>
								}
							}
						}
						@if (!showVertical() && !homefieldCarouselEnabled()) {
							@for (
								item of scheme?.items;
								let index = $index;
								track trackByCertona($index, item);
							) {
								<div
									class="product-recommendation-cards"
									[class.quickview]="certonaQuickviewEnabled() && showQVButtons() || isCartOOSRecs()">
									@if (!item) {
										<hmf-skeleton class="hmf-pr-xs" height="260px" width="200px" [loading]="true" [inline]="true" />
									}
									@if (item && index < productDisplayLimit()) {
										@if (certonaQuickviewEnabled() && showQVButtons() || isCartOOSRecs()) {
											<div
												class="dcsg-card hmf-h-100"
												[class.oos-product-recommendation]="isOOSRecommendations()"
												[class.product-recommendation]="!isOOSRecommendations()"
												[class.product-recommendation--vertical-grid]="isVerticalGrid()"
											>
												<a class="hmf-display-flex hmf-flex-column hmf-align-items-stretch url"
												[attr.data-em]="sponsored() ? 'pdp_sponsored_dsgproductpage_' + index : ''"
												[id]="sponsored() && item.ID ? 'spa-carousel-' + item.ID : ''"
												href="javascript:void(0)"
												(click)="handleProductCardClicked(item)">
													<ng-container *ngTemplateOutlet="cardContent; context: { item: item }"></ng-container>
												</a>
												<button hmf-button
														id="certona-add-to-cart-{{ index }}"
														[variant]="'secondary'"
														[size]="'medium'"
														[loading]="false"
														[disabled]="false"
														[label]="isCartOOSRecs() ? 'Replace' : atcCardText()"
														class="hmf-mx-0 hmf-px-xs"
														(click)="openQuickviewPanel(item.ID, item.URL)">
													{{ isCartOOSRecs() ? 'Replace' : atcCardText() }}
												</button>
											</div>
										} @else {
											<a class="dcsg-card hmf-h-100 hmf-display-flex hmf-flex-column hmf-align-items-stretch url"
											[class.oos-product-recommendation]="isOOSRecommendations()"
											[class.product-recommendation]="!isOOSRecommendations()"
											[class.product-recommendation--vertical-grid]="isVerticalGrid()"
											[attr.data-em]="sponsored() ? 'pdp_sponsored_dsgproductpage_' + index : ''"
											[id]="sponsored() && item.ID ? 'spa-carousel-' + item.ID : ''"
											href="javascript:void(0)"
											(click)="handleProductCardClicked(item)">
												<ng-container *ngTemplateOutlet="cardContent; context: { item: item }"></ng-container>
											</a>
										}
									}
								</div>
							}
						}
					</div>
				</div>
			}

			@if (isSidePanelRecs()) {
				@if (isSidePanelRecsRedesign()) {
					<div class="product-recs-grid-container">
						<h3 class="hmf-header-bold-m hmf-mb-0">{{scheme?.certonaDisplayText}}</h3>
						@for (item of scheme?.items; track trackBySchema($index, item)) {
							<div>
								<hmf-product-card
									class="cursor-pointer"
									[productData]="recommendationDataService.mapSchemaItemToProductCardData(item) ?? undefined"
									[showReviewsStars]="false"
									[showATC]="false"
									[size]="redesignCardSize()"
									variant="recommendation"
									(cardClicked)="handleProductCardClicked(item)">
								</hmf-product-card>
							</div>
						}
					</div>
				} @else {
					<div class="hmf-display-flex hmf-mx-0 hmf-justify-content-center cart-product-recommendation-card-container">
						@for (item of scheme?.items; track trackBySchema($index, item)) {
							<div class="col-5half cart-product-recommendations dcsg-card">
								<a class="hmf-display-flex hmf-flex-column hmf-align-items-stretch hmf-h-100 url" [href]="item?.URL">
									<source type="image/webp" [srcset]="item?.ImageURL"/>
									<img
										class="hmf-align-self-center cross-sell-img product-image"
										alt="a product"
										[src]="item?.ImageURL"
										[ngClass]="imageSize()"
										loading="lazy"
									/>
									<div class="hmf-align-self-start cross-sell-desc product-name line-clamp">
										<span [innerHTML]="item?.Name"></span>
									</div>
									<div class="list-view-item-price hmf-align-self-start">
										@if (recommendationDataService.isSeePriceInCart(item)) {
											<span>See Price In Cart</span>
										} @else {
											<span>{{ item?.minofferprice | currency }}</span>
											@if (item?.minofferprice !== item?.maxofferprice) {
												<span>&nbsp;to&nbsp;{{ item?.maxofferprice | currency }}</span>
											}
										}
									</div>
								</a>
							</div>
						}
					</div>
				}
			}
		</div>
	}
}

<ng-template #cardContent let-item="item" let-index="index">
	@let mobileEagerImageCount = index < 2;
	@let desktopEagerImagesCount = !isMobile() && index < 4;
	@let shouldLoadEagerImage = isCartOOSRecs() && !forceLazyLoadOOOImages() && (mobileEagerImageCount || desktopEagerImagesCount);
	@let shouldPrioritizeImage = isCartOOSRecs() && !forceLazyLoadOOOImages() && index === 0;
	<img class="hmf-align-self-center cross-sell-img product-image"
		alt="a product"
		[src]="item.ImageURL"
		[ngClass]="imageSize()"
		[class.reserve-image-height]="reserveLegacyCardImageHeight()"
		[loading]="shouldLoadEagerImage ? 'eager' : 'lazy'"
		[attr.fetchpriority]="shouldPrioritizeImage ? 'high' : 'auto'" />

	<div class="hmf-align-self-start cross-sell-desc product-name line-clamp">
		{{ item.Name | productRecsItemName }}
	</div>

	<div class="list-view-item-price hmf-align-self-start">
		@if (recommendationDataService.isSeePriceInCart(item)) {
			<span>
				{{ filterBy() === 'cartempty_rr' || filterBy() === 'cart2_rr' ? 'Add To Cart To See Price' : 'See Price In Cart' }}
			</span>
		} @else if (item.isSkuRecommendation) {
      <span>{{ item.offerprice | currency }}</span>
		} @else {
      <span [class.product-discount]="productHasDiscount(item)">{{ item.minofferprice | currency }}</span>
      @if (item.minofferprice !== item.maxofferprice) {
        <span [class.product-discount]="productHasDiscount(item)">
					{{ isVerticalGrid() ? ' - ' : '&nbsp;to&nbsp;' }}{{ item.maxofferprice | currency }}
				</span>
      }
      @if (productHasDiscount(item)) {
        <span class="hmf-text-decoration-linethrough product-original-price">{{ item.minlistprice | currency }}</span>
        @if (item.minlistprice !== item.maxlistprice) {
          <span class="hmf-text-decoration-linethrough product-original-price">
					- {{ item.maxlistprice | currency }}
				</span>
        }
      }
    }
	</div>
</ng-template>
